import * as React from 'react'
import { StripeSubscriptionFieldConnected } from './StripeSubscriptionFieldConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const StripeSubscriptionFieldExamples = () => {
  return (
    <div className="StripeSubscriptionFieldExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <StripeSubscriptionFieldConnected />
      </Provider>
    </div>
  )
}
